import reducer from './reducers';

export { default as offersOperations } from './operations';
export { default as offersSelectors } from './selectors';

export default reducer;
